'use-client';
import React from 'react';
import type { IFooterContainerProps } from '../../../FooterContainer.types';
import SolidScreen from '../../../../ScreenWidthContainer/viewer/skinComps/BaseScreen/SolidScreen';
import FooterContainer from '../../FooterContainer';

const SolidScreenFooter: React.FC<
  Omit<IFooterContainerProps, 'skin'>
> = props => <FooterContainer {...props} skin={SolidScreen}></FooterContainer>;

export default SolidScreenFooter;
